import React from "react";

export const NotFound = () => {
   return <div>Component not found. Please add to @/react/index.tsx</div>;
};
